import React, { Component } from "react";
import { connect } from "react-redux";
import { func, string } from "prop-types";
import DocumentCaptureUI from "../DocumentCaptureUI";
// import { saveAs } from "file-saver";

import {
  preview,
  setCroppedFirstPage,
  selectDocumentType,
  captureTimeout,
  userTimeout,
} from "logic/actions/documentCapture";
import { changeCamera } from "logic/actions/camera";
import { documentsSave } from "logic/actions/api/document";
import { go, previous } from "logic/actions/navigation";

import {
  CANVAS_DOCUMENT_FOUND,
  CANVAS_DOCUMENT_NOT_FOUND,
  CANVAS_DOCUMENT_PASSED,
  ID_CARD_RATIO,
  PASSPORT,
  PASSPORT_RATIO,
  DOCUMENT_SIDE_BACK,
  DOCUMENT_SIDE_FRONT,
  DOCUMENT_INSTRUCTIONS,
  OTHER_DOCUMENT,
} from "logic/enums/document";
import { WEBRTC } from "logic/enums/captureTypes";

import {
  logEvent,
  document_changed_camera,
  document_autocapture_started,
  document_autocapture_finished,
  document_autocapture_failed,
  document_capture_timeout,
  document_capture_back,
} from "logic/eventLogger";
import DaonErrorBox from "Components/common/DaonErrorBox";
import * as S from "./PageDocumentCapturePortrait.styles";
import { webView } from "logic/webView";
import {
  BACKGROUND_EVENT,
  GRANT_CAMERA_PERMISSION,
  MRZ_CHECK_ERROR_MESSAGE,
  ON_CHECK_DOCUMENT_OCR,
} from "logic/enums/composite";
import { isIOS, isMobile } from "logic/deviceType";
import CaptureButtonPanel from "../../../CaptureButtonPanel";
import { toggleNetworkWarnings } from "logic/actions/apiFetch";
import VisiblityChangeHandler from "../../common/VisiblityChangeHandler";
import {
  VERIFY_IDENTITY,
  DOCUMENT_CAPTURE_INSTRUCTIONS,
} from "logic/enums/pages";
import { withTranslation } from "react-i18next";
import { setSelectedCamera } from "logic/actions/camera";
import PageContent from "Components/PageContent";
import DaonButton from "Components/common/DaonButton";
import { base64ImageRegex } from "logic/enums/base64Image";
import { ANDROID, IOS } from "logic/enums/composite";
import { steps } from "logic/steps";
import { NFC_STEP } from "logic/enums/steps";
import { BarcodeSideEnum } from "logic/enums/barcode";
import {
  BARCODE_TRUST_NUM_FRAMES,
  SAAS_BARCODE_NUM_FRAMES,
  SAAS_NUM_FRAMES,
} from "logic/enums/numberOfFrames";
import { getTranslatedContent } from "logic/documentTranslation";
/*global MobileFormHandler*/

const START = 0;
const CAPTURING = 1;
const ERROR = -1;
const DOC_CAPTURE_TERMINAL_ERROR_CODE = 916;
let resolvePromise;
let rejectPromise;
let ocrPromiseTimeout;
let isNfcStepPresent;
const OCR_BRIDGE_TIMEOUT_MS = 12000;

export class PageDocumentCapturePortrait extends Component {
  static propTypes = {
    preview: func,
    documentType: string,
  };

  constructor(props) {
    super(props);
    this.canvasRef = new React.createRef();

    this.state = {
      pending: true,
      message: "",
      formState: START,
      captureMethod: "WEBRTC",
      cameraPermission: true,
      hideNative: false,
      showSwitchCameraButton: true,
      videoMetadataLoaded: false,
      coords: {},
      count: 0,
      messageList: [],
      switchingCamera: false,
      aspectRatio: this.getAspectRatioFromProps(this.props),
      showRemainingTime: false,
      captureSessionId: 0,
      compatRecoveryMode: false,
      params: {
        showIndicator: true,
        showExclamationMark: true,
      },
    };
    this.searchRetryTimeout = null;
    this.searchRetryScheduled = false;
    this.detectorErrorStreak = 0;
    this.detectorErrorWindowStartTs = 0;
    this.hasAttemptedCompatRecovery = false;
    this.setShowRemainingTime = this.setShowRemainingTime.bind(this);
  }

  getDetectorMessageCode = (err) => {
    if (err && typeof err === "object" && typeof err.messageCode === "string") {
      return err.messageCode;
    }
    return null;
  };

  getBooleanFlag = (value, defaultValue = false) => {
    if (typeof value === "boolean") return value;
    if (typeof value === "string") {
      if (value.toLowerCase() === "true") return true;
      if (value.toLowerCase() === "false") return false;
    }
    return defaultValue;
  };

  resetDetectorErrorCircuit = () => {
    this.detectorErrorStreak = 0;
    this.detectorErrorWindowStartTs = 0;
  };

  getDetectorErrorCode = (err) => {
    if (typeof err === "number") return err;
    if (err && typeof err === "object") {
      if (typeof err.code === "number") return err.code;
      if (typeof err.errorCode === "number") return err.errorCode;
      if (typeof err.messageCode === "number") return err.messageCode;
    }
    return null;
  };

  getDetectorRejectionDetails = (err) => {
    if (!err || typeof err !== "object") return null;

    const {
      rejectionReasonCode,
      rejectionReasonMetric,
      stableDetections,
      nPassedFrames,
      hasBestFrame,
      hasBestFrameUnprocessedFrame,
      shouldSaveUnprocessed,
      qualitySummary,
      thresholds,
    } = err;

    if (!rejectionReasonCode) return null;

    return {
      rejectionReasonCode,
      rejectionReasonMetric,
      stableDetections,
      nPassedFrames,
      hasBestFrame,
      hasBestFrameUnprocessedFrame,
      shouldSaveUnprocessed,
      qualitySummary,
      thresholds,
    };
  };

  getEstimatedDetectorRejection = ({ err, qualityScore }) => {
    const stableDetections = Number(qualityScore?.stableDetections || 0);
    const nPassedFrames = Number(this.getConfiguredPassedFrames() || 0);

    if (stableDetections < nPassedFrames) {
      return {
        estimatedReasonCode: "REJ_STABLE_COUNT",
        estimatedReasonMetric: "stableDetections<nPassedFrames",
        stableDetections,
        nPassedFrames,
      };
    }

    const qs = qualityScore || {};
    const thresholds =
      this.state.docCaptureInstance?.config?.qualityDefaultThresholds || {};

    if (!qs.isQualityAvailable) {
      return {
        estimatedReasonCode: "REJ_QUALITY_GATE",
        estimatedReasonMetric: "isQualityAvailable",
      };
    }

    if (!qs.isResultAvailable) {
      return {
        estimatedReasonCode: "REJ_QUALITY_GATE",
        estimatedReasonMetric: "isResultAvailable",
      };
    }

    const qualityChecks = [
      ["qualitySize", "sizeLowerLimit", "min"],
      ["qualityAspectRatio", "aspectRatioUpperLimit", "max"],
      ["maxInternalAngle", "maxInternalAngleUpperLimit", "max"],
      ["minInternalAngle", "minInternalAngleLowerLimit", "min"],
      ["verticalDistorsion", "vertDistortUpperLimit", "max"],
      ["horizontalDistorsion", "horizDistortUpperLimit", "max"],
      ["localBlur", "blurLowerLimit", "min"],
      ["glareFixed", "glareFixedUpperLimit", "max"],
      ["croppedResolution", "croppedResolutionLowerLimit", "min"],
    ];

    for (const [metric, thresholdKey, mode] of qualityChecks) {
      const value = qs?.[metric];
      const threshold = thresholds?.[thresholdKey];
      if (!Number.isFinite(Number(value)) || !Number.isFinite(Number(threshold))) {
        continue;
      }

      const numericValue = Number(value);
      const numericThreshold = Number(threshold);
      const fails =
        mode === "min"
          ? numericValue < numericThreshold
          : numericValue > numericThreshold;

      if (fails) {
        return {
          estimatedReasonCode: "REJ_QUALITY_GATE",
          estimatedReasonMetric: metric,
          metricValue: numericValue,
          metricThreshold: numericThreshold,
          stableDetections,
          nPassedFrames,
        };
      }
    }

    const detectorMessageCode = this.getDetectorMessageCode(err);
    if (detectorMessageCode === "DocumentCapture.no_barcode_found") {
      return {
        estimatedReasonCode: "REJ_BARCODE_FAIL",
        estimatedReasonMetric: "$reader.barcode",
      };
    }
    if (detectorMessageCode === "DocumentCapture.no_mrz_found") {
      return {
        estimatedReasonCode: "REJ_MRZ_FAIL",
        estimatedReasonMetric: "$reader.mrz",
      };
    }

    return {
      estimatedReasonCode: "REJ_UNKNOWN",
      estimatedReasonMetric: detectorMessageCode || "unknown",
      stableDetections,
      nPassedFrames,
    };
  };

  shouldTriggerCompatRecovery = ({ err, estimatedRejection }) => {
    if (this.hasAttemptedCompatRecovery) return false;
    if (this.state.compatRecoveryMode) return false;

    const detectorMessageCode = this.getDetectorMessageCode(err);
    const estimatedReasonCode = estimatedRejection?.estimatedReasonCode;
    const estimatedReasonMetric = estimatedRejection?.estimatedReasonMetric;

    const isUnknownError =
      detectorMessageCode === "DocumentCapture.unknown_error" ||
      this.getDetectorErrorCode(err) === 999;
    const isLikelyQualityGate =
      estimatedReasonCode === "REJ_QUALITY_GATE" &&
      (estimatedReasonMetric === "qualitySize" ||
        estimatedReasonMetric === "croppedResolution" ||
        estimatedReasonMetric === "isQualityAvailable" ||
        estimatedReasonMetric === "isResultAvailable");

    if (!isLikelyQualityGate) {
      return false;
    }

    return (
      this.detectorErrorStreak >= 10 &&
      (isUnknownError || isLikelyQualityGate)
    );
  };

  isTerminalDetectorError = (err) =>
    this.getDetectorErrorCode(err) === DOC_CAPTURE_TERMINAL_ERROR_CODE;

  getDetectorErrorDisplayMessage = (err) => {
    if (!err) return this.props.t("DocumentCapture.unknown_error");
    if (typeof err === "string") return err;
    if (typeof err === "object") {
      if (err.messageCode) {
        const translated = this.props.t(err.messageCode);
        if (translated !== err.messageCode) return translated;
      }
      if (err.message) return err.message;
    }
    return this.props.t("DocumentCapture.unknown_error");
  };

  getSearchRearmDelayAfterDetectorError = (err) => {
    const code = this.getDetectorErrorCode(err);
    const messageCode = this.getDetectorMessageCode(err);
    const messageCodeLower =
      typeof messageCode === "string" ? messageCode.toLowerCase() : "";
    const stableDetections = Number(err?.stableDetections || 0);
    const nPassedFrames = Number(
      err?.nPassedFrames || this.getConfiguredPassedFrames() || 0
    );

    // Keep the loop alive but slower for guidance states to avoid request storms.
    if (messageCodeLower.includes("hold") || messageCodeLower.includes("passed")) {
      // Once stable frame count is met, re-arm faster to reduce sticky hold loops.
      if (nPassedFrames > 0 && stableDetections >= nPassedFrames) return 180;
      return 320;
    }

    // Unknown fallback noise should re-arm more conservatively.
    if (messageCodeLower.includes("unknown_error")) return 650;
    if (code === 999 || code === 0) return 650;

    return 120;
  };

  shouldQueueDetectorMessage = (err) => {
    if (this.isTerminalDetectorError(err)) return true;

    const code = this.getDetectorErrorCode(err);
    const messageCode =
      err && typeof err === "object" ? err.messageCode : null;
    const message =
      err && typeof err === "object"
        ? err.message || ""
        : typeof err === "string"
        ? err
        : "";
    const messageLower = message.toLowerCase();
    const messageCodeLower =
      typeof messageCode === "string" ? messageCode.toLowerCase() : "";

    // Keep guidance messages, but suppress generic non-terminal unknown/fallback text.
    if (messageCode === "DocumentCapture.unknown_error") return false;
    if (messageCodeLower.includes("unknown_error")) return false;
    if (code === 999) return false;
    if (code === 0) return false;
    if (messageLower === "unknown_error") return false;
    if (messageLower.includes("unknown error")) return false;
    if (messageLower.includes("unknown_error")) return false;
    if (messageLower.includes("please try again")) return false;

    return true; 
  };

  getConfiguredPassedFrames = () => {
    const defaultFrames = !!this.props.mobileAppPlatform
      ? BARCODE_TRUST_NUM_FRAMES
      : this.handleScanBarcode()
      ? SAAS_BARCODE_NUM_FRAMES
      : SAAS_NUM_FRAMES;

    return defaultFrames;
  };

  getConfiguredShouldSaveUnprocessed = () => {
    let defaultShouldSaveUnprocessed =
      (!this.props.mobileAppPlatform ||
        !this.props.isNFCReady ||
        !isNfcStepPresent) &&
      (this.props.shouldNotSendUnprocessedDocuments === "true" ||
        !this.props.shouldNotSendUnprocessedDocuments);

    // Sample-app parity: for passport keep unprocessed enabled unless explicitly forced.
    if (this.props.documentType === PASSPORT) {
      defaultShouldSaveUnprocessed = true;
    }

    return {
      defaultShouldSaveUnprocessed,
      shouldSaveUnprocessed: defaultShouldSaveUnprocessed,
    };
  };

  getQualityThresholdOverrides = ({ compatMode = false } = {}) => {
    return {
      sizeLowerLimit: 0.05,
      croppedResolutionLowerLimit: 0.4,
    };
  };

  createDocCaptureInstance = ({ compatMode = false } = {}) => {
    const allowNonContinuousFrames = this.getBooleanFlag(
      this.props.allowNonContinuousFrames,
      false
    );
    const isPassportCapture = this.props.documentType === PASSPORT;
    const shouldDownscaleFrameFromProps = this.getBooleanFlag(
      this.props.shouldDownscaleFrame,
      !this.props.mobileAppPlatform || isPassportCapture
    );
    const shouldDownscaleFrame = compatMode
      ? true
      : shouldDownscaleFrameFromProps;
    const configuredCompressionRate = Number(this.props.compressionRate);
    const defaultCompressionRate = 0.95;
    const compressionRate = compatMode
      ? 0.92
      : Number.isFinite(configuredCompressionRate) &&
        configuredCompressionRate > 0 &&
        configuredCompressionRate <= 1
      ? configuredCompressionRate
      : defaultCompressionRate;
    const shouldScanMrz = this.getBooleanFlag(this.props.shouldScanMrz, false);
    const {
      defaultShouldSaveUnprocessed,
      shouldSaveUnprocessed,
    } = this.getConfiguredShouldSaveUnprocessed();
    const width = compatMode
      ? 1280
      : this.props.docCaptureWidth
      ? parseInt(this.props.docCaptureWidth)
      : 1920;
    const height = compatMode
      ? 720
      : this.props.docCaptureHeigth
      ? parseInt(this.props.docCaptureHeigth)
      : 1080;
    const qualityDefaultThresholds = this.getQualityThresholdOverrides({
      compatMode,
    });

    return new Daon.DocumentCapture({
      width,
      height,
      rejectLowResolutionCameras: false,
      croppingTolerance: this.props.croppingTolerance,
      facingMode: "environment",
      developerMode: false,
      compressionRate,
      shouldSaveUnprocessed,
      allowNonContinuousFrames: isIOS(navigator.userAgent)
        ? allowNonContinuousFrames
        : false,
      allowNonContinuouslyFrames: isIOS(navigator.userAgent)
        ? allowNonContinuousFrames
        : false,
      shouldDownscaleFrame,
      shouldScanBarcode: this.handleScanBarcode(),
      shouldScanMrz,
      debugMode: false,
      mrzReaderUrl: process.env.REACT_APP_MRZ_READER_URL,
      qualityDefaultThresholds,
    });
  };

  attemptCompatRecovery = () => {
    this.clearSearchRetry();
    this.resetDetectorErrorCircuit();

    try {
      if (this.state.docCaptureInstance) {
        this.state.docCaptureInstance.stopCamera();
        this.state.docCaptureInstance.destroy();
      }

      const nextDocCaptureInstance = this.createDocCaptureInstance({
        compatMode: true,
      });

      this.setState(
        (prevState) => ({
          docCaptureInstance: nextDocCaptureInstance,
          pending: true,
          message: "",
          formState: START,
          videoMetadataLoaded: false,
          messageList: [],
          switchingCamera: false,
          captureSessionId: prevState.captureSessionId + 1,
          compatRecoveryMode: true,
        }),
        () => {
        }
      );
    } catch (err) {
      this.setState({
        pending: false,
        formState: ERROR,
        message:
          this.props.t("DocumentCapture.unknown_error") ||
          "An error occurred. Please try again.",
      });
    }
  };

  clearSearchRetry = () => {
    if (this.searchRetryTimeout) {
      clearTimeout(this.searchRetryTimeout);
      this.searchRetryTimeout = null;
    }
    this.searchRetryScheduled = false;
  };

  searchForDocumentSafely = (reason, delayMs = 0) => {
    const targetCaptureSessionId = this.state.captureSessionId;

    const runSearch = () => {
      this.searchRetryScheduled = false;
      this.searchRetryTimeout = null;

      if (targetCaptureSessionId !== this.state.captureSessionId) {
        return;
      }

      if (this.state.formState === ERROR) {
        return;
      }
      if (!this.state.docCaptureInstance) {
        return;
      }
      try {
        if (typeof this.state.docCaptureInstance.searchForDocument !== "function") {
          return;
        }

        const searchResult = this.state.docCaptureInstance.searchForDocument(
          this.state.aspectRatio
        );
        const searchResultType =
          searchResult && typeof searchResult.then === "function"
            ? "promise"
            : typeof searchResult;
        if (searchResult && typeof searchResult.then === "function") {
          searchResult
            .then((value) => {
            })
            .catch((err) => {
            });
        }
      } catch (err) {
      }
    };

    if (delayMs > 0) {
      if (this.searchRetryScheduled) {
        return;
      }
      this.searchRetryScheduled = true;
      this.searchRetryTimeout = setTimeout(runSearch, delayMs);
      return;
    }

    this.clearSearchRetry();
    runSearch();
  };

  getAspectRatioFromProps = (props) => {
    if (props.aspectRatio && Number.isFinite(Number(props.aspectRatio))) {
      return Number(props.aspectRatio);
    }

    return props.documentType === PASSPORT
      ? PASSPORT_RATIO.aspectRatio
      : ID_CARD_RATIO.aspectRatio;
  };

  getWasmLoadConfig = (onIDModuleInited) => {
    const idCaptureBaseUrl = window.location.origin;
    const shouldSaveUnprocessed =
      this.getConfiguredShouldSaveUnprocessed().shouldSaveUnprocessed;
    const config = {
      idCaptureBaseUrl,
      urlIDDetectorWasm: idCaptureBaseUrl + "/DaonIDCapture.wasm",
      shouldSaveUnprocessed,
      allowNonContinuouslyFrames: false,
      onIDModuleInited,
      dynamsoftLicenseKey: process.env.REACT_APP_DYNAMSOFT_LICENSE_KEY,
    };
    return config;
  };

  loadDocumentWasmModules = (onIDModuleInited) => {
    const { docCaptureInstance } = this.state;
    if (!docCaptureInstance || typeof docCaptureInstance.loadWasmModules !== "function") {
      return;
    }

    const fullConfig = this.getWasmLoadConfig(onIDModuleInited);
    try {
      docCaptureInstance.loadWasmModules(fullConfig);
    } catch (err) {
      docCaptureInstance.loadWasmModules({
        idCaptureBaseUrl: fullConfig.idCaptureBaseUrl,
        shouldSaveUnprocessed: fullConfig.shouldSaveUnprocessed,
        allowNonContinuouslyFrames: fullConfig.allowNonContinuouslyFrames,
        onIDModuleInited,
      });
    }
  };

  normalizeDetectorErrorArgs = (...args) => {
    const [first, second, third, fourth] = args;
    if (first && typeof first === "object" && first.errorMessage) {
      return {
        coordinates: first.coordinates,
        err: first.errorMessage,
        qualityScore: first.quality,
        processingTimes: first.processingTimes,
      };
    }

    return {
      coordinates: first,
      err: second,
      qualityScore: third,
      processingTimes: fourth,
    };
  };

  normalizeCapturedPayload = (...args) => {
    const [first, second, third, fourth, fifth] = args;
    if (first && typeof first === "object") {
      const docImage =
        first.docImage ||
        first.image ||
        first.croppedUnprocessedImage ||
        first.croppedImage ||
        first.base64 ||
        first.dataUrl ||
        null;

      const unprocessedImage =
        first.unprocessedImage ||
        first.unprocessedFrame ||
        first.downscaledUnprocessedFrame ||
        first.blob ||
        null;

      const coordinates = first.coordinates || second || null;
      const quality = first.quality || third || null;
      const scanningRegion = first.scanningRegion || fifth || null;

      return {
        docImage,
        coordinates,
        quality,
        unprocessedImage,
        scanningRegion,
      };
    }

    return {
      docImage: first,
      coordinates: second,
      quality: third,
      unprocessedImage: fourth,
      scanningRegion: fifth,
    };
  };

  UNSAFE_componentWillMount() {
    this.setState({
      docCaptureInstance: this.createDocCaptureInstance(),
    });
  }

  componentDidMount() {
    isNfcStepPresent = steps.findIndex((x) => x.name === NFC_STEP) > -1;
    if (this.props.mobileAppPlatform === ANDROID) {
      window.sendToNativePromise = this.sendToNativePromise;
      window.onOcrReadingFailed = this.onOcrReadingFailed;
      window.onOcrReadingSuccess = this.onOcrReadingSuccess;
    }
    if (this.props.mobileAppPlatform === IOS) {
      window.addEventListener("ocrEvent", this.ocrEventHandler);
      window.addEventListener("appState", this.appState);
    }

    document.title = `${this.props.t(
      "PageDocumentCapture.title"
    )} | Onboarding`;
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.aspectRatio !== this.props.aspectRatio ||
      prevProps.documentType !== this.props.documentType
    ) {
      const nextAspectRatio = this.getAspectRatioFromProps(this.props);
      if (nextAspectRatio !== this.state.aspectRatio) {
        this.setState({ aspectRatio: nextAspectRatio });
      }
    }
  }

  getBack = () => {
    logEvent(document_capture_back, {
      captureTime: performance.now() - this.state.startTime || 0,
    });
    if (this.props.shouldSkipInstructionsPage) this.props.go(VERIFY_IDENTITY);
    else this.props.previous();
  };

  appState = (e) => {
    try {
      let response = JSON.parse(e.detail.data);
      if (response.appState === BACKGROUND_EVENT) {
        this.props.go(VERIFY_IDENTITY);
      }
    } catch (e) {}
  };

  setShowRemainingTime(value) {
    this.setState({ showRemainingTime: value });
  }
  ocrEventHandler = (e) => {
    try {
      let response = JSON.parse(e.detail.data);
      if (response.passed) {
        this.documentCapturePassedEvent(
          this.state.coordinates,
          this.state.qualityScore
        );
        this.preview();
      } else {
        this.setState({
          messageList: [
            {
              err: {
                message: MRZ_CHECK_ERROR_MESSAGE,
                messageCode: "DocumentCapture.OCR",
              },
              rank: 1,
            },
            ...this.state.messageList,
          ],
        });
        this.searchForDocumentSafely("ocr_event_failed", 150);
      }
    } catch (e) {}
  };

  documentCapturePassedEvent = (coordinates, qualityScore) => {
    logEvent(document_autocapture_finished, {
      captureTime: performance.now() - this.state.startTime,
      side: this.props.base64CroppedFirstPage ? "back" : "front",
      qualityScore,
      coordinates,
    });
  };

  preview = () => {
    this.props.preview({
      base64: this.state.base64,
      blob: this.state.blob,
      isRejected: false,
      captureMethod: this.state.captureMethod,
    });
    clearInterval(this.messagePriorityInterval);
  };

  handleScanBarcode = () => {
    if (
      this.props.checkBarcode &&
      this.props.document.barcodeSide &&
      this.props.document.barcodeSide !== BarcodeSideEnum.NONE
    )
      return (
        (!this.props.base64CroppedFirstPage &&
          this.props.document.barcodeSide === BarcodeSideEnum.FRONT) ||
        (this.props.base64CroppedFirstPage &&
          this.props.document.barcodeSide === BarcodeSideEnum.BACK)
      );

    return false;
  };

  startIdDetector = () => {
    let supportsCapturePassedV2 = null;
    let supportsCapturePassed = null;
    try {
      if (typeof this.state.docCaptureInstance?.checkSDKSupportFor === "function") {
        supportsCapturePassedV2 = this.state.docCaptureInstance.checkSDKSupportFor(
          "onCapturePassedV2"
        );
        supportsCapturePassed = this.state.docCaptureInstance.checkSDKSupportFor(
          "onCapturePassed"
        );
      }
    } catch (e) {
    }
    const handleDocumentCaptured = async (...captureArgs) => {
      this.resetDetectorErrorCircuit();
      const { docImage, coordinates, quality, unprocessedImage } =
        this.normalizeCapturedPayload(...captureArgs);

      if (docImage && docImage !== "data:") {
        this.setState({ base64: docImage, blob: unprocessedImage });
        if (
          this.props.mobileAppPlatform &&
          this.props.isNFCReady &&
          (this.props.singlePaged ||
            this.props.documentType === PASSPORT ||
            this.props.base64CroppedFirstPage) &&
          isNfcStepPresent
        ) {
          try {
            if (this.props.mobileAppPlatform === ANDROID) {
              await this.sendToNativePromise(docImage);
              this.documentCapturePassedEvent(coordinates, quality);
              this.preview();
            } else if (this.props.mobileAppPlatform === IOS) {
              this.setState({ coordinates, qualityScore: quality });
              webView(ON_CHECK_DOCUMENT_OCR, docImage.replace(base64ImageRegex, ""));
            }
          } catch (e) {
            this.setState({
              messageList: [
                {
                  err: {
                    message: MRZ_CHECK_ERROR_MESSAGE,
                    messageCode: "DocumentCapture.OCR",
                  },
                  rank: 1,
                },
                ...this.state.messageList,
              ],
            });

            this.searchForDocumentSafely("native_ocr_failed", 150);
          }
        } else {
          this.documentCapturePassedEvent(coordinates, quality);
          this.preview();
        }
      } else {
      }
    };

    this.state.docCaptureInstance.startIDDetector({
      onIDDetectorInitialized: (error, debugData) => {
        this.resetDetectorErrorCircuit();
        this.setState({
          pending: false,
          switchingCamera: false,
          message: this.state.switchingCamera
            ? this.props.t("PageDocumentCapturePortrait.position_document")
            : "",
        });
        this.getPriorityMessage();
        if (isMobile(navigator.userAgent)) {
          this.tapHandler();
        } else {
          // Keep desktop/web flows from stalling in START state when no explicit tap occurs.
          this.searchForDocumentSafely("detector_initialized_bootstrap", 250);
        }
      },

      onIDDetectorError: (...errorArgs) => {
        const { coordinates, err, qualityScore, processingTimes } =
          this.normalizeDetectorErrorArgs(...errorArgs);
        const isTerminal = this.isTerminalDetectorError(err);
        const shouldQueueMessage = this.shouldQueueDetectorMessage(err);
        const detectorCode = this.getDetectorErrorCode(err);
        const detectorMessageCode = this.getDetectorMessageCode(err);
        let compatRecoveryTriggered = false;

        if (!shouldQueueMessage) {
        } else if (detectorMessageCode === "DocumentCapture.passed") {
        } else if (detectorMessageCode === "DocumentCapture.passed_partial") {
        } else if (detectorMessageCode) {
        } else if (detectorCode !== null) {
        } else {
        }

        try {
          const rejectionDetails = this.getDetectorRejectionDetails(err);
          const estimatedRejection = this.getEstimatedDetectorRejection({
            err,
            qualityScore,
          });

          if (!isTerminal) {
            this.detectorErrorStreak += 1;
          }

          if (
            !isTerminal &&
            this.shouldTriggerCompatRecovery({ err, estimatedRejection })
          ) {
            this.hasAttemptedCompatRecovery = true;
            compatRecoveryTriggered = true;
            this.attemptCompatRecovery();
            return;
          }

          if (shouldQueueMessage) {
            this.setState({
              messageList: [
                { err, qualityScore, coordinates, processingTimes },
                ...this.state.messageList,
              ],
            });
          } else {
          }

          if (isTerminal) {
            this.clearSearchRetry();
            this.setState({
              formState: ERROR,
              pending: false,
              message: this.getDetectorErrorDisplayMessage(err),
            });
            this.state.docCaptureInstance?.stopCamera?.();
          }
        } catch (callbackErr) {
        } finally {
          if (!isTerminal && !compatRecoveryTriggered) {
            const rearmDelayMs = this.getSearchRearmDelayAfterDetectorError(err);
            this.searchForDocumentSafely("on_id_detector_error", rearmDelayMs);
          } else if (compatRecoveryTriggered) {
          }
        }
      },

      onDocumentCaptured: handleDocumentCaptured,
      // Compatibility fallback: some SDK/runtime variants emit capture-passed callbacks.
      onCapturePassed: (...captureArgs) => {
        return handleDocumentCaptured(...captureArgs);
      },
      // Compatibility fallback for newer callback name.
      onCapturePassedV2: (...captureArgs) => {
        return handleDocumentCaptured(...captureArgs);
      },
      // Compatibility fallback: some SDK/runtime variants may still emit legacy callback.
      onIDDetection: (...legacyArgs) => {
        return handleDocumentCaptured(...legacyArgs);
      },
      nPassedFrames: this.getConfiguredPassedFrames(),
      downloadFrames: false,
      debug: process.env.NODE_ENV === "development",
    });
  };

  onCaptureTimeout = () => {
    if (this.props.shouldSkipInstructionsPage) return;
    this.props.userTimeout();
    this.props.captureTimeout();
    logEvent(document_capture_timeout, {
      documentType: this.props.documentType,
      documentCountry: this.props.dialCountryNum,
      retryCount: this.props.retryCount,
    });
    this.props.go(DOCUMENT_CAPTURE_INSTRUCTIONS);
  };
  sendToNativePromise = (image) => {
    return new Promise((resolve, reject) => {
      if (ocrPromiseTimeout) {
        clearTimeout(ocrPromiseTimeout);
      }
      resolvePromise = resolve;
      rejectPromise = reject;

      ocrPromiseTimeout = setTimeout(() => {
        if (typeof rejectPromise === "function") {
          rejectPromise(new Error("OCR bridge timeout"));
        }
        resolvePromise = null;
        rejectPromise = null;
        ocrPromiseTimeout = null;
      }, OCR_BRIDGE_TIMEOUT_MS);

      webView(ON_CHECK_DOCUMENT_OCR, image.replace(base64ImageRegex, ""));
    });
  };

  onOcrReadingFailed = (message) => {
    if (ocrPromiseTimeout) {
      clearTimeout(ocrPromiseTimeout);
      ocrPromiseTimeout = null;
    }
    if (typeof rejectPromise === "function") {
      rejectPromise(message);
    }
    resolvePromise = null;
    rejectPromise = null;
  };
  onOcrReadingSuccess = () => {
    if (ocrPromiseTimeout) {
      clearTimeout(ocrPromiseTimeout);
      ocrPromiseTimeout = null;
    }
    if (typeof resolvePromise === "function") {
      resolvePromise("aaa");
    }
    resolvePromise = null;
    rejectPromise = null;
  };
  onCameraStarted = () => {
    document.title = `Document Capture| Onboarding`;
    if (this.state.videoMetadataLoaded && !this.state.switchingCamera) return;
    this.setState({ videoMetadataLoaded: true, switchingCamera: false });
    setTimeout(() => {
      this.loadDocumentWasmModules(({ isLoaded, error }) => {
          if (isLoaded) {
            setTimeout(() => {
              this.startIdDetector();
            }, 1500);
          }
          if (error) {
          }
        });
    }, 1000);

    if (this.state.docCaptureInstance.camera.videoTracks.length) {
      const trackSettings =
        this.state.docCaptureInstance.camera.videoTracks[0].getSettings();
      this.setState({
        streamWidth: trackSettings.width,
        streamHeight: trackSettings.height,
      });
      const device = this.state.docCaptureInstance.camera.videoTracks[0];
      const { deviceId, groupId } = device.getSettings();
      this.props.setSelectedCamera({
        label: device.label,
        deviceId,
        groupId,
      });
    }
  };

  onVisibilityChange = (isVisible) => {
    if (
      this.state.captureMethod !== "NATIVE" &&
      !this.state.pending &&
      isVisible
    )
      this.props.go(VERIFY_IDENTITY);
  };

  getPriorityMessage() {
    if (this.messagePriorityInterval) {
      clearInterval(this.messagePriorityInterval);
    }

    this.messagePriorityInterval = setInterval(() => {
      if (this.state.messageList.length) {
        const rankedMessage = this.state.messageList.find(
          (message) => message.rank
        );
        const highestPriorityMessage =
          rankedMessage || this.state.messageList[0];

        if (highestPriorityMessage) {
          if (
            highestPriorityMessage.err?.code === 900 ||
            highestPriorityMessage.err?.message === MRZ_CHECK_ERROR_MESSAGE
          ) {
            this.state.docCaptureInstance.setStrokeStyle(
              CANVAS_DOCUMENT_PASSED,
              this.state.aspectRatio,
              {
                showIndicator: true,
                showCheckmark: true,
                overlayBackground: this.props.overlayBackground,
              }
            );
          } else if (highestPriorityMessage.err?.code === 910) {
            this.state.docCaptureInstance.setStrokeStyle(
              CANVAS_DOCUMENT_NOT_FOUND,
              this.state.aspectRatio,
              {
                showIndicator: true,
                showExclamationMark: true,
                overlayBackground: this.props.overlayBackground,
              }
            );
          } else {
            this.state.docCaptureInstance.setStrokeStyle(
              CANVAS_DOCUMENT_FOUND,
              this.state.aspectRatio,
              {
                showIndicator: true,
                showExclamationMark: true,
                overlayBackground: this.props.overlayBackground,
              }
            );
          }

          logEvent(document_autocapture_failed, {
            error: highestPriorityMessage.err.message,
            qualityScore: highestPriorityMessage.qualityScore,
            coordinates: highestPriorityMessage.coordinates,
            side: this.props.base64CroppedFirstPage ? "back" : "front",
          });
          this.setState({
            message:
              this.props.t(highestPriorityMessage.err.messageCode) ===
              highestPriorityMessage.err.messageCode
                ? highestPriorityMessage.err.message
                : this.props.t(highestPriorityMessage.err.messageCode),
            messageList: [],
          });
        }
      }
    }, 600);
  }

  flipCamera = () => {
    this.setState({ aspectRatio: 1 / this.state.aspectRatio }, () => {
      this.state.docCaptureInstance.setScanningRegion(this.state.aspectRatio);
      this.state.docCaptureInstance.setStrokeStyle();
    });
  };

  tapHandler = () => {
    const { documentType } = this.props;
    logEvent(document_autocapture_started, {
      documentType: documentType,
      width: this.props.width,
      height: this.props.height,
    });

    const startTime = performance.now();
    this.resetDetectorErrorCircuit();
    this.setState({
      captureMethod: WEBRTC,
      formState: CAPTURING,
      message: "",
      networkError: false,
      startTime,
    });

    this.searchForDocumentSafely("tap_handler");
  };

  changeCamera = (cameraId) => {
    this.setState(
      {
        switchingCamera: true,
        videoMetadataLoaded: false,
        formState: START,
      },
      () => {
        this.props.changeCamera(cameraId);
        logEvent(document_changed_camera);
        clearInterval(this.messagePriorityInterval);
      }
    );
  };

  cameraPermissionDenied = () => {
    this.setState({
      cameraPermission: false,
      message: this.props.t("PageDocumentCapturePortrait.please_enable_camera"),
      isError: true,
      retryCameraInit: false,
      pending: false,
      formState: ERROR,
    });
  };

  retryCameraInit = () => {
    if (this.props.mobileAppPlatform === IOS) webView(GRANT_CAMERA_PERMISSION);
    this.setState({
      cameraPermission: true,
      retryCameraInit: true,
      message: "",
      isError: false,
      pending: true,
      formState: START,
    });
  };

  componentWillUnmount() {
    this.clearSearchRetry();
    this.state.docCaptureInstance.stopCamera();
    this.state.docCaptureInstance.destroy();
    if (this.props.mobileAppPlatform === ANDROID) {
      window.sendToNativePromise = null;
      window.onOcrReadingFailed = null;
      window.onOcrReadingSuccess = null;
    }
    if (this.props.mobileAppPlatform === IOS)
      window.removeEventListener("ocrEvent", this.ocrEventHandler);
    window.removeEventListener("appState", this.appState);
    this.setState({ docCaptureInstance: null });
    clearInterval(this.messagePriorityInterval);
  }

  render() {
    const message =
      this.state.message ||
      this.props.t("PageDocumentCapturePortrait.position_document");

    let translationPage;
    let translatedContent;

    const documentSide = this.props.base64CroppedFirstPage
      ? DOCUMENT_SIDE_BACK
      : DOCUMENT_SIDE_FRONT;

    const documentType = this.props.documentType || OTHER_DOCUMENT;

    if (
      this.props.documentLabel &&
      !this.props.documentLabel.includes("PageVerifyIdentity")
    ) {
      const documentSideTranslated = this.props.t(
        `PageDocumentCaptureInstructions.document_label_${documentSide}`
      );
      const subtitlePrefix = this.props.t(
        "PageDocumentCaptureInstructions.instuctions_small"
      );

      translationPage = DOCUMENT_INSTRUCTIONS;
      translatedContent = getTranslatedContent({
        documentSide,
        translate: this.props.t,
        translationPage,
        subtitlePrefix,
        documentLabel: this.props.documentLabel,
        documentSideTranslated,
      });
    } else {
      translationPage = DOCUMENT_CAPTURE_INSTRUCTIONS;
      translatedContent = getTranslatedContent({
        documentSide,
        translate: this.props.t,
        translationPage,
        documentType,
      });
    }
    const title = translatedContent?.title;
    return (
      <PageContent
        toggleLoading={this.state.pending}
        hideFooter={true}
        isDarkMode={true}
        backButtonClick={this.getBack}
        justifyContent={"center"}
        title={title}
      >
        <VisiblityChangeHandler onVisibilityChange={this.onVisibilityChange} />

        <DocumentCaptureUI
          key={this.state.captureSessionId}
          docCaptureInstance={this.state.docCaptureInstance}
          onCameraStarted={this.onCameraStarted}
          captureMethod={this.state.captureMethod}
          cameraPermissionDenied={this.cameraPermissionDenied}
          retryCameraInit={this.state.retryCameraInit}
          onCaptureTimeout={this.onCaptureTimeout}
          setShowRemainingTime={this.setShowRemainingTime}
        />
        <p>{this.state.userMessage}</p>
        <S.DocumentCaptureFooter isError={this.state.isError}>
          {this.state.message && this.state.formState == CAPTURING ? (
            <DaonErrorBox
              style={{
                margin: "10px auto 50px auto",
              }}
              neutral={this.state.cameraPermission}
              title={
                !this.state.cameraPermission &&
                this.props.t("Common.no_camera_title")
              }
              message={ !this.state.showRemainingTime ? (
                message === "passed" || message === "passed_partial"
                  ? //@TODO translate this message
                    "Hold!"
                  : message
              ) : this.props.t("Common.time_remaining_message_document")
              }
            />
          ) : (
            <S.DocumentMessage aria-live="polite">
              {" "}
              {this.props.t(
                isMobile(navigator.userAgent)
                  ? "DocumentCapture.position_document_inside_area"
                  : "PageDocumentCapturePortrait.position_document"
              )}{" "}
            </S.DocumentMessage>
          )}
          {!this.state.cameraPermission && (
            <DaonButton
              onClick={this.retryCameraInit}
              style={{ margin: "0 auto" }}
            >
              {this.props.t("Common.confirm_camera_permission")}
            </DaonButton>
          )}
          {(this.state.videoMetadataLoaded || this.state.switchingCamera) && (
            <CaptureButtonPanel
              onCaptureClick={this.tapHandler}
              onChangeCamera={this.changeCamera}
              flipCameraHandler={
                this.props.documentType === PASSPORT ? false : this.flipCamera
              }
              showSwitchCameraButton={this.state.showSwitchCameraButton}
              disabled={
                this.state.formState !== START || this.state.switchingCamera
              }
              shouldDisableCameraButton={this.state.switchingCamera}
              shouldHideCaptureButton={
                this.state.formState !== START || isMobile(navigator.userAgent)
              }
            />
          )}
        </S.DocumentCaptureFooter>
      </PageContent>
    );
  }
}

const componentWithTranslation = withTranslation()(PageDocumentCapturePortrait);

export default connect(
  (state) => {
    const {
      documentType,
      isNFCReady,
      base64CroppedFirstPage,
      base64CroppedSecondPage,
      aspectRatio,
      retryCount,
      document,
    } = state.documentCapture;
    const { width, height, singlePaged, count, dialCountryNum } =
      state.documentCaptureConfiguration;
    const tenant = state.configuration?.tenant;
    const { mobileAppPlatform } = state.composite;

    const documentProcessingDelayMs =
      state.configuration?.extraConfig?.featureFlags?.documentProcessingDelay;
    const checkBarcode =
      state.configuration.extraConfig?.steps?.document?.options.checkBarcode;
    const shouldSkipInstructionsPage =
      state.configuration.extraConfig?.steps?.document?.options
        .shouldSkipInstructionsPage;

    const docCaptureWidth =
      state.configuration.extraConfig?.steps?.document?.options?.width ||
      state.configuration.extraConfig?.featureFlags.width;
    const docCaptureHeigth =
      state.configuration.extraConfig?.steps?.document?.options?.height ||
      state.configuration.extraConfig?.featureFlags.heigth;
    const allowNonContinuousFrames =
      state.configuration.extraConfig?.steps?.document?.options
        ?.allowNonContinuousFrames || false;

    const shouldNotSendUnprocessedDocuments =
      state.configuration.extraConfig?.featureFlags
        ?.shouldNotSendUnprocessedDocuments;
    const croppingTolerance =
      state.configuration.extraConfig?.steps?.document?.options
        ?.croppingTolerance;
    const overlayBackground =
      state.configuration.extraConfig?.steps?.document?.options?.overlayColor ??
      "rgba(0, 0, 0, 1)";
    const compressionRate =
      state.configuration.extraConfig?.steps?.document?.options
        ?.compressionRate;
    const shouldDownscaleFrame =
      state.configuration.extraConfig?.steps?.document?.options
        ?.shouldDownscaleFrame;

    return {
      documentType,
      aspectRatio,
      base64CroppedFirstPage,
      base64CroppedSecondPage,
      count,
      width,
      height,
      isNFCReady,
      singlePaged,
      tenant,
      mobileAppPlatform,
      dialCountryNum,
      documentProcessingDelayMs,
      docCaptureWidth,
      docCaptureHeigth,
      allowNonContinuousFrames,
      shouldNotSendUnprocessedDocuments,
      croppingTolerance,
      compressionRate,
      shouldDownscaleFrame,
      retryCount,
      document,
      checkBarcode,
      shouldSkipInstructionsPage,
      documentLabel: state.documentCapture.documentLabel,
      overlayBackground,
    };
  },
  {
    go,
    previous,
    preview,
    captureTimeout,
    userTimeout,
    changeCamera,
    setCroppedFirstPage,
    documentsSave,
    toggleNetworkWarnings,
    selectDocumentType,
    setSelectedCamera,
  }
)(componentWithTranslation);
